import { REST_METHOD, REST_URL } from 'constants/index';
import { requestNotification } from './api';

export interface NotificationParam {
    title: string,
    subtitle: string,
    body: string,
    notificationType: string,
    userID: string,
  }

async function sendNotification(payload?: NotificationParam){
  try{
    let params = {
      nativeMessage: {
        title: payload?.title,
        subtitle: payload?.subtitle,
        body: payload?.body
      },
      metadata: {
        notificationType: payload?.notificationType,
        userID: payload?.userID
      }
    }
    const requestParams = {
      url: `${REST_URL.NOTIFICATION}${REST_URL.NOTI_SEND}`,
      method: `${REST_METHOD.POST}`,
      data: params,
    };

    const response = await requestNotification(requestParams);
    return response?.data;
  }
  catch(error){
    console.error('Failed to send notification', error);
  }
}

const NotificationServices = {
  sendNotification
}

export default NotificationServices;